"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetMembersStatusByTeamId = exports.makeGetMembersSelectorsByTeamId = void 0;

var _ramda = require("ramda");

var _members = require("./members.reducer");

var getMembersState = function getMembersState(state) {
  return state.modules.teams.members;
};

var makeGetMembersByTeamId = function makeGetMembersByTeamId(teamId) {
  return (0, _ramda.pipe)(getMembersState, function (state) {
    return teamId && state[teamId] || _members.teamMemberByTeamInitialState;
  });
};

var makeGetMembersSelectorsByTeamId = function makeGetMembersSelectorsByTeamId(teamId) {
  return _members.teamMembersAdapter.getSelectors(makeGetMembersByTeamId(teamId));
};

exports.makeGetMembersSelectorsByTeamId = makeGetMembersSelectorsByTeamId;

var makeGetMembersStatusByTeamId = function makeGetMembersStatusByTeamId(teamId) {
  return (0, _ramda.pipe)(makeGetMembersByTeamId(teamId), (0, _ramda.prop)('status'));
};

exports.makeGetMembersStatusByTeamId = makeGetMembersStatusByTeamId;